// Desc: This component is responsible for rendering the content of a message. 
// Update: 08/04/2025

// React and Material-UI components
import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';

// Components and styles used in this component
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

const RenderMessageContent = ({ message, header = null }) => {


    function formatWhatsAppMessage(message) {


        let formatted = message.replace(/\\n/g, '\n');      
        formatted = formatted.replace(/(?<!\*)\*(?!\*)/g, '**');
      

        return formatted;
      }
      

    if (!message) return null;

    switch (message.type) {
        case 'text':
        case 'whatsapp':

            return (
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12}>
                        <Card sx={{
                            background: message.fromMe ? '#E2FFC7' : '#fefefe',
                            padding: '10px',
                            borderRadius: '4px',
                            fontSize: { xs: '8px', lg: '10px', xl: '12px' },
                            width: '100%',
                            minWidth: header !== null && header.type === 'image' ? '250px' : 'auto',
                            maxWidth: '100%',
                            border: 'none',
                            color: '#000',
                            whiteSpace: 'pre-wrap',  // Garante que quebras de linha e espaços sejam preservados
                            display: header !== null ? 'flex' : 'inline-block',
                            flexDirection: 'column',
                            gap: '5px'
                        }}>
                            {
                                header !== null ? (
                                    <>
                                    {
                                        header.type === "text" ? (
                                            <Typography sx={{ fontWeight: 600, color: '#000', padding: { xs: '10px 10px 0 10px', sm: '16px 16px 0 16px' } }}>
                                                {header.content}
                                            </Typography>
                                        ) : header.type === "image" ? (
                                            <Box sx={{ padding: { xs: '10px 10px 0 10px', sm: '16px 16px 0 16px' } }}>
                                                <Box component="img" src={header.content} sx={{ width: '100%', height: { xs: '80px', lg: '110px' }, objectFit: 'cover' }} />
                                            </Box>
                                        ) : null
                                    }
                                    </>
                                ) : null
                            }
                            <CardContent sx={{ '.css-46bh2p-MuiCardContent-root': { padding: { xs: '10px', sm: '16px' } } }}>
                                <div style={{ lineHeight: '1.6', overflowWrap: 'break-word' }}>
                                    <ReactMarkdown
                                        remarkPlugins={[breaks]} // Assegure-se de que o plugin está sendo passado corretamente
                                    >
                                        {formatWhatsAppMessage(message.message)}
                                    </ReactMarkdown>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            );

        case 'img':
            return (
                <div style={{
                    background: '#E2FFC7', padding: '10px', borderRadius: '4px', maxWidth: '90%',
                }}>
                    <img src={message.message} alt="Image" style={{ maxWidth: '100%', maxHeight: '300px' }} />
                </div>
            );

        case 'sms':

            if (!message.message) return null;
            return (
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12}>
                        <Card sx={{
                            background: '#cce6f3',
                            padding: '10px',
                            borderRadius: '4px',
                            fontSize: { xs: '8px', lg: '10px', xl: '12px' },
                            minWidth: '250px',
                            maxWidth: '100%',
                            border: 'none',
                            color: '#000',
                        }}>
                            <CardContent>
                                <div style={{ lineHeight: '1.6' }}>
                                    <ReactMarkdown remarkPlugins={[breaks]}>
                                        {message.message}
                                    </ReactMarkdown>
                                </div>

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            );

        default:
            return null;
    }
};

export default RenderMessageContent;
